import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  message: "Please click OK to continue.",
};

const requireRefreshSlice = createSlice({
  name: "requireRefresh",
  initialState,
  reducers: {
    openRequireRefreshDialog(state, { payload }) {
      state.open = true;
      state.message =
        typeof payload?.message === "string" && payload.message
          ? payload.message
          : initialState.message;
    },
    closeRequireRefreshDialog(state) {
      state.open = false;
    },
  },
});

export const { openRequireRefreshDialog, closeRequireRefreshDialog } =
  requireRefreshSlice.actions;
export default requireRefreshSlice.reducer;
